import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { $neutralGray50 } from '../../../../styles/colors/primitives'
import Img from '../../../Img' // task #67: canonical image component
import Cta from '../../../CtaV2'

function ProductImageAndText({ title, text, image, ctaV2 }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.title}>
            <SimpleBlockContent
              blocks={title.text}
              highlight={title.highlight}
              highlightSx={`color: ${$neutralGray50};`}
              highlightExactMatch={true}
              noSpace
            />
          </div>
          <div className={styles.textBody}>
            <SimpleBlockContent blocks={text} noSpace/>
          </div>
          <div className={styles.ctaWrapper}>
            <Cta
              {...ctaV2}
              fullWidth
            />
          </div>
        </div>

        {
          image && (
            <div className={styles.imageWrapper}>
              {/* task #67: descriptor via <Img> */}
              <Img
                image={image}
                alt={title.text}
                layout="fill"
                objectFit="contain"
              />
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ProductImageAndText
